import * as React from "react";
import { Field } from "redux-form";
import {
  StyledFormControl,
  StyledAutoSelectInputLabel
} from "../../../../../styles/form";
import { PeoplePickerAutoCompleteComponent } from "./index";
import { AccountCircleRounded } from "@material-ui/icons";
import {
  getStringBeforeSubstring,
  getStringAfterSubstring
} from "../../../../../utils";
// import Grid from "@material-ui/core/Grid";

class PeoplePickerAutoComplete extends React.Component<any, any> {
  public state = {
    data: []
  };

  constructor(props: any) {
    super(props);
  }

  public shouldComponentUpdate(nextProps: any) {
    if (
      nextProps.data.length ||
      nextProps.data.length !== this.props.data.length ||
      nextProps.disabled !== this.props.disabled
    ) {
      return true;
    } else {
      return false;
    }
  }

  public componentWillReceiveProps(nextProps: any) {
    if (nextProps.data) {
      const myData1 = nextProps.data.map((data: any, index: any) => {
        let value = data.id;
        if (
          nextProps.name === "solutionOwner" ||
          nextProps.name === "caSolutionOwner" ||
          nextProps.name === "solutionTeam"
        ) {
          value = data.userName;
        }
        return {
          label: this.getLabelValue(data),
          chipLabel: this.getChipLabel(data),
          value
        };
      });
      this.setState({ data: myData1 });
    }
  }

  public render() {
    const {
      disabled,
      name,
      label,
      onChange,
      required,
      isMulti,
      onInputChange,
      menuIsOpen
    } = this.props;
    return (
      <StyledFormControl>
        <StyledAutoSelectInputLabel>
          {label} {required ? <span className="req-label">*</span> : null}
        </StyledAutoSelectInputLabel>

        <Field
          value=""
          name={name}
          component={PeoplePickerAutoCompleteComponent}
          label={label}
          onChange={onChange}
          data={this.state.data}
          disabled={disabled}
          isMulti={isMulti}
          onInputChange={onInputChange}
          menuIsOpen={menuIsOpen}
        />
      </StyledFormControl>
    );
  }

  /**
   * Function returning label value/text as per provided data
   */
  private getLabelValue = (data: any) => {
    if (data.isSolutionOwner || data.isSolutionTeam) {
      if (data.userName.includes(":")) {
        const username = (
          <div>
            <div style={{ display: "inline-block" }}>
              <div style={{ position: "relative", bottom: "5px" }}>
                <AccountCircleRounded />
              </div>
            </div>
            <div style={{ display: "inline-block", marginLeft: "5px" }}>
              <div>{getStringBeforeSubstring(data.userName, ":")}</div>
              <div>{getStringAfterSubstring(data.userName, ":")}</div>
            </div>
          </div>
        );
        return username;
      } else {
        const username = (
          <div>
            <div style={{ display: "inline-block" }}>
              <div>
                <AccountCircleRounded />
              </div>
            </div>
            <div style={{ display: "inline-block", marginLeft: "5px" }}>
              <div style={{ position: "relative", bottom: "5px" }}>
                {data.userName}
              </div>
            </div>
          </div>
        );
        return username;
      }
    } else {
      return data.name || data.description;
    }
  };

  private getChipLabel = (data: any) => {
    if (data.userName.includes(":")) {
      const name = getStringBeforeSubstring(data.userName, ":");
      return name;
    } else {
      return data.userName;
    }
  };
}

export default PeoplePickerAutoComplete;
